import ExcelJS from 'exceljs';
import file from '../../../assets/sheets/near_miss.xlsx'; // Your imported Excel file
import { replace } from 'utils/common/replaceIdsByValues';
import { format } from 'date-fns';

const ExcelEditor = () => {

    const handleEditColumns = async (data, users) => {
        try {
            const updatedData = replace(data, users)

            const response = await fetch(file);
            const arrayBuffer = await response.arrayBuffer();
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(arrayBuffer);
            const worksheet = workbook.getWorksheet(1);

            const row17 = worksheet.getRow(17);
            const cellC17 = row17.getCell(3);
            cellC17.value = updatedData?.local_reporter

            const row18 = worksheet.getRow(18);
            const cellC18 = row18.getCell(3);
            cellC18.value = updatedData?.reportado_por;

            const row20 = worksheet.getRow(20);
            const cellC20 = row20.getCell(3);
            cellC20.value = updatedData?.local;

            const row22 = worksheet.getRow(22);
            const cellC22 = row22.getCell(3);
            cellC22.value = format(new Date(updatedData?.dataAcontecimento), 'yyyy-MM-dd')

            const row23 = worksheet.getRow(23);
            const cellC23 = row23.getCell(3);
            cellC23.value = updatedData?.descricao;

            const row28 = worksheet.getRow(28);
            const cellC28 = row28.getCell(4);
            cellC28.value = updatedData?.humanos;

            const cellC28B = row28.getCell(11);
            cellC28B.value = updatedData?.materiais;

            const cellC28C = row28.getCell(12);
            cellC28C.value = updatedData?.outros;

            const row29 = worksheet.getRow(29);
            const cellC29 = row29.getCell(3);
            cellC29.value = updatedData?.medidas_imediatas;

            const row30 = worksheet.getRow(30);
            const cellC30 = row30.getCell(3);
            cellC30.value = updatedData?.resposaveis;

            row20.commit();
            row30.commit();

            const editedBuffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob([editedBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = `${updatedData.local}_${format(new Date(updatedData.dataAcontecimento), 'yyyy-MM-dd')}_near_miss.xlsx`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

        } catch (error) {
            console.error('Error editing Excel file:', error);
        }
    };

    return { handleEditColumns }
};

export default ExcelEditor;
